import React, { useContext, useState } from 'react';
import AppContext from "../../AppContext";
import { Link } from "react-router-dom";
import { FormService, Api, Config, ModalService, Lang } from "./../../services/Services";
import { BaseSubmit, InputDiv, RegiBtns } from "./../utils/Utils";
import Regi from './Regi';
import { GenForm } from '../Hocs/Hocs';

const fields = [
	{ name: "code", label: "Code", validation: { notEmpty: true, activationCode: true }, toUpperCase: true, placeholderLang: ["activate_login", "label_activation_key"] },
	{ name: "check", type: "checkbox", validation: { checked: true }, labelLang: ["activate_login", "label_accept_terms"] },
];
const fieldsObj = {};
const apiFunc = async () => await Api.activationCode(fieldsObj.code[0]);

const Activation = ({ errors, submit, servError, isLoginUpd }) => {	//
	const context = useContext(AppContext);
	fieldsObj.code = useState("");
	fieldsObj.check = useState(true);
	FormService.fieldsHoist(fields, fieldsObj);

	const openAppInNewWindow = () => {
		window.open('https://play.google.com/store/apps/details?id=com.jumboard.webeeparents', 
		'appwindow', 
		'width=300,height=350'); 
	   return false;
	}

	const openInNewWindow = () => {
		window.open('https://ap.webee-world.com/', 
		'newwindow', 
		'width=350,height=550'); 
	   return false;
	}

	const submitFunc = async () => {
		if (await submit()) {
			context.UserService.activationCode = fieldsObj.code[0];
			ModalService.openBlueCover(<Regi />);
		}
	}

	const seekFocus = posToLook => {
		FormService.seekFocus(posToLook, fields, submitFunc);
	}

	const isLoginToTrue = () => {
		isLoginUpd(true); // Update the 'isLogin' state to true
	  };

	if (context.UserService.user) { return null; }

	return (
		<>
		    {Config.STATUS_APP != 1 && Config.STATUS_APP != 3 ?
			<>
			<ul className="form" >
			<li >	
				<InputDiv fieldObj={fields[0]} error={errors[fields[0].name]} seekFocus={seekFocus} />
				<p  >{Lang.activate_login.activation_key_loc}</p>
			</li>
			<li ><InputDiv seekFocus={seekFocus} fieldObj={fields[1]} error={errors[fields[1].name]} tabIndex="2" postLabelContent={<p><Link onClick={() => ModalService.closeBlueCover()} to="/pages/terms-of-use" className="underline" >{Lang.activate_login.goto_term_of_use}</Link></p>} /></li>
		</ul>
		<RegiBtns servError={servError} >
			<BaseSubmit onClick={submitFunc} label={Lang.activate_login.butten_register} />
		</RegiBtns>	
		</>	
		:
		<p className="space_size">
		<p className="non-app msgForParent" dangerouslySetInnerHTML={{__html:Lang.activate1.qr_tablet_instructions}}></p>
		<p className="only-app form" dangerouslySetInnerHTML={{__html:Lang.activate1.qr_mobile_instructions}}></p>
		<div className="linksForParent">
			<div>
			<span onClick={openAppInNewWindow}><img className="qr_size" alt="get it on Google Play"  src="/assets/images/google-play.png" /></span>
			<br></br>	
			<img className="qr_size" alt="scan the QR code"  src="/assets/images/webeeparents_android_qr.png" />
			</div>
			<div>
			<span onClick={openInNewWindow}><img className="qr_size" alt="soon in App store" src="/assets/images/apple-eng.png" /></span>
			<br></br>	
			<img className="qr_size" alt="scan the QR code" src="/assets/images/webeeparents_ios_qr.png" />
				</div>
		</div>
		<RegiBtns servError={servError} >
			<BaseSubmit onClick={isLoginToTrue} label={Lang.activate1.registered_button} />
		</RegiBtns>	
		</p>
	}
	
		</>
	);
}

export default GenForm(Activation, { fields, apiFunc, langFail: ["errorTexts", "activation_fail"], langSuc: ["errorTexts", "activation_suc"] });
